import React from 'react';

import processing_activities_messages from 'messages/processing_activities_messages';
import RequestClarificationModal from 'pages/ProcessingActivities/ProcessingActivitiesAssetReviewsPage/_components/RequestClarificationModal';

type Props = {
  loading?: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void | Promise<void>;
  open: boolean;
};

const DpiaReassessDialog: React.FC<Props> = ({ loading = false, onClose, onConfirm, open }) => {
  const messages = processing_activities_messages.asset_ropa.modals.reassess;

  return (
    <RequestClarificationModal
      commentLabel={messages.reason}
      confirmLabel={messages.confirm}
      helpLabel={messages.help}
      loading={loading}
      onClose={onClose}
      onConfirm={onConfirm}
      open={open}
      titleLabel={messages.title}
    />
  );
};

export default DpiaReassessDialog;
